import React from 'react';
import { generatePath, useParams } from 'react-router-dom';

import Authorization from 'components/MissedPayments/Authorization/Authorization';
import FinancialDashboardNavigation from 'components/FinancialCheckup/FinancialDashboardNavigation';
import { RoutePath } from 'enums/Routes';
import { useNavigate } from 'hooks/useNavigate';
import { FlowComponentType } from 'routes/types';

const UpdateAchAuthorization = (props: FlowComponentType) => {
  const navigate = useNavigate();
  const { loanId } = useParams<{ loanId: string }>();

  const handleBackClick = () => {
    navigate(generatePath(RoutePath.UpdateAchConnect, { loanId }) as RoutePath);
  };

  return (
    <Authorization
      {...props}
      NavigationComponent={FinancialDashboardNavigation}
      onBackClick={handleBackClick}
      title="Confirm your new payment settings"
      description={
        <p>Review and sign a quick authorization form to finish updating your loan payments. It only takes a minute.</p>
      }
      buttonText="Review and sign"
      returnPath={generatePath(RoutePath.UpdateAchWaitingAuthorization, { loanId })}
    />
  );
};

export default UpdateAchAuthorization;
